import { create } from "zustand";

interface RelaunchStore {
    type: string;
    setType: (type: string) => void;

    days: number;
    setDays: (days: number) => void;

    text: string;
    setText: (text: string) => void;

    relaunchs: any[];
    setRelaunchs: (relaunchs: any[]) => void;

    reset: () => void;
}

export const useRelaunchStore = create<RelaunchStore>((set) => ({
    type: "",
    setType: (type: string) => set({ type }),

    days: 0,
    setDays: (days: number) => set({ days }),

    text: "",
    setText: (text: string) => set({ text }),

    relaunchs: [],
    setRelaunchs: (relaunchs: any[]) => set({ relaunchs }),

    reset: () => set({ type: "", days: 0, text: "" }),
}));